import React from "react"
import PropTypes from "prop-types"

const MailIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 37 29" >
    <path d="M31.603702,3.6251032 L6.37030835,3.6251032 L17.7288052,12.0311157 C18.3864068,12.5066473 19.5884297,12.5066473 20.2452051,12.0311157 L31.603702,3.6251032 Z M33.3724518,10.6036952 L37,7.54493694 L37,29 L0,29 L0,6.84237196 L3.62754817,9.92342073 L3.62754817,23.5404674 L10.5422779,14.8397244 L13.4667872,16.9920005 L6.80154956,25.3748968 L30.220756,25.3748968 L23.8950588,17.4452416 L26.8203943,15.2929655 L33.3724518,23.5173513 L33.3724518,10.6036952 Z M37,0 L37,3.7613232 L22.3989327,14.8851311 C21.447228,15.5876961 20.2228995,15.9270077 18.9754393,15.9270077 C17.7511108,15.9270077 16.5267823,15.5876961 15.5750776,14.8851311 L0,3.05875822 L0,0 L37,0 Z"></path>
  </svg>
)

MailIcon.propTypes = {
  style: PropTypes.object
}

export default MailIcon



// WEBPACK FOOTER //
// ./src/components/icons/mail-icon.jsx